/**
 * LOGISPRD-14320: 할당우선순위 화면의 v3 출고일정 정책 API 실호출 전환 플래그.
 * LOGISPRD-15139 부터 화면은 항상 v3 실 API 를 쓰고 이 플래그를 읽지 않는다. 정의만 남긴다.
 */
export const ALLOCATION_PRIORITY_V3_API_FLAG = 'feature.allocationPriority.v3Api'

/** 이번 범위의 정책 scope 고정값 (LLD 범위 결정). */
export const SHIPPER_CODE = 'MUSINSA'
export const CUT_TYPE = 'B2C'

export const POLICY_BASE_PATH = '/api/v3/outbound-schedule-policies'

/** 정책 층. 창고 priority 와는 별개다. */
export const POLICY_PRIORITY = { BASE: 1, SPECIAL: 2, DAY: 3 } as const

/** 화면이 저장하는 슬롯의 priorityType 은 항상 PACKING 이다 (LLD REQ-06). */
export const SAVED_PRIORITY_TYPE = 'PACKING'

export const dayExceptionName = (date: string): string => `당일 ${date}`

/** 화면 순위 대상 기본 목록(서버 targets 가 없을 때). 화면 계약이며 실 서버 DTO 가 아니다. */
export const CENTER_ORDER = Array.from({ length: 13 }, (_, i) => i)
/** 운영일 D 의 시간 순서: D-1일 23시 → D일 0~22시. */
export const OPERATING_HOURS = [23, ...Array.from({ length: 23 }, (_, i) => i)]
export const MAX_WAIT_MINUTES = 540
export const WAIT_STEP_MINUTES = 30
export const MAX_SCENARIO_NAME_LENGTH = 6
export const GLOBAL_PRIORITY_SEED = [0, 4, 8] as const
